import { gql } from '@apollo/client';

export const ENROLMENT = gql`
  fragment enrolment on SchoolEnrolmentData {
    id
    emisNumber
    numberEnrolled
    numberWithoutID
    term
    year
    circuit {
      id
      name
    }
    district {
      id
      name
    }
    grade {
      id
      value
    }
    institution {
      id
      name
    }
    promotionStatus {
      id
      name
    }
  }
`;
